import { Skeleton } from "@mui/material";
import classNames from "classnames";
import styles from "../table.module.scss";

interface InstallmentsTableSkeletonProps {
  count?: number;
  className?: string;
}

const COLUMNS = ["Installment", "Amount", "Status", "Due date", "Paid on"];

/** Same five columns and row height as the loaded installments table. */
function InstallmentsTableSkeleton({
  count = 3,
  className,
}: InstallmentsTableSkeletonProps) {
  return (
    <div className={classNames(styles.card, className)}>
      <div className={styles.heading}>
        <Skeleton variant="text" width={140} height={28} />
      </div>
      <div className={styles.scroll}>
        <table className={styles.table}>
          <thead>
            <tr>
              {COLUMNS.map((column) => (
                <th key={column} className={styles.th}>
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: count }).map((_, index) => (
              <tr key={index}>
                <td className={styles.td}>
                  <Skeleton variant="text" width={44} height={20} />
                </td>
                <td className={styles.td}>
                  <Skeleton variant="text" width={82} height={20} />
                </td>
                <td className={styles.td}>
                  <Skeleton
                    variant="rounded"
                    width={72}
                    height={22}
                    sx={{ borderRadius: "16px" }}
                  />
                </td>
                <td className={styles.td}>
                  <Skeleton variant="text" width={88} height={20} />
                </td>
                <td className={styles.td}>
                  <Skeleton variant="text" width={88} height={20} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default InstallmentsTableSkeleton;
